import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const filterS1PositionsSchema = z.object({
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  strategy_from_id_equals: z.string().optional(),
  strategy_to_id_equals: z.string().optional(),
  strategy_from_name_contains: z.string().optional(),
  strategy_to_name_contains: z.string().optional(),
});

export type FilterS1PositionsSchema = z.infer<typeof filterS1PositionsSchema>;
const filterS1PositionsFields = filterS1PositionsSchema.keyof().enum;

export function FilterS1Positions() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "date",
      type: "dateRange",
      label: t(`${Tables.S1_POSITIONS}.searchbox.date`, {
        defaultValue: "Date",
      }),
      from: { name: "date_from" },
      to: { name: "date_to" },
      col_span: 2,
    },
    {
      name: filterS1PositionsFields.strategy_from_id_equals,
      label: t(`${Tables.S1_POSITIONS}.searchbox.strategy_from_id_equals`, {
        defaultValue: "Strategy from ID",
      }),
      type: "input",
      input_type: "number",
    },
    {
      name: filterS1PositionsFields.strategy_from_name_contains,
      label: t(`${Tables.S1_POSITIONS}.searchbox.strategy_from_name_contains`, {
        defaultValue: "Strategy from name",
      }),
      type: "input",
    },
    {
      name: filterS1PositionsFields.strategy_to_id_equals,
      label: t(`${Tables.S1_POSITIONS}.searchbox.strategy_to_id_equals`, {
        defaultValue: "Strategy to ID",
      }),
      type: "input",
      input_type: "number",
    },
    {
      name: filterS1PositionsFields.strategy_to_name_contains,
      label: t(`${Tables.S1_POSITIONS}.searchbox.strategy_to_name_contains`, {
        defaultValue: "Strategy to name",
      }),
      type: "input",
    },
  ];

  return (
    <FilterTable
      columns={2}
      client={Clients.S1_QUANTILIA}
      schema={filterS1PositionsSchema}
      tableName={Tables.S1_POSITIONS}
      customBuildPath={() => Tables.S1_POSITIONS}
      fields={fields}
    />
  );
}
